import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _readOnlyError from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-18fdd1b5"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "h-main"
};
var _hoisted_2 = {
  class: "h-left"
};
var _hoisted_3 = {
  class: "px-side"
};
var _hoisted_4 = {
  class: "px-side-inner"
};
var _hoisted_5 = {
  class: "top-bar"
};
var _hoisted_6 = {
  class: "clan-list"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "h-middle"
};
var _hoisted_9 = {
  class: "m-left"
};
var _hoisted_10 = {
  class: "section"
};
var _hoisted_11 = {
  class: "top-bar"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "卷首", -1);
});

var _hoisted_13 = /*#__PURE__*/_createTextVNode(" \"(如前言、序、谱论、凡例、编修名录等) \" ");

var _hoisted_14 = [_hoisted_12, _hoisted_13];
var _hoisted_15 = {
  class: "m-content"
};
var _hoisted_16 = {
  key: 0,
  class: "catalogue"
};
var _hoisted_17 = ["onClick"];
var _hoisted_18 = {
  class: "catalogue-l"
};
var _hoisted_19 = {
  class: "item-title"
};
var _hoisted_20 = {
  class: "name"
};
var _hoisted_21 = {
  class: "catalogue-m"
};

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "catalogue-r"
  }, null, -1);
});

var _hoisted_23 = {
  key: 1,
  class: "empty"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加目录", -1);
});

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加谱文", -1);
});

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加源流", -1);
});

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt-box"
  }, [/*#__PURE__*/_createElementVNode("p", null, "您还没有卷首内容，赶快新建吧~")], -1);
});

var _hoisted_28 = {
  class: "section"
};
var _hoisted_29 = {
  class: "top-bar"
};

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "正文目录", -1);
});

var _hoisted_31 = /*#__PURE__*/_createTextVNode(" \"(如源流、碑文、恩荣录、祠堂、坟茔、字辈等)\" ");

var _hoisted_32 = [_hoisted_30, _hoisted_31];
var _hoisted_33 = {
  class: "m-content"
};
var _hoisted_34 = {
  key: 0,
  class: "catalogue"
};
var _hoisted_35 = ["onClick"];
var _hoisted_36 = {
  class: "catalogue-l"
};
var _hoisted_37 = {
  class: "item-title"
};
var _hoisted_38 = {
  class: "name"
};
var _hoisted_39 = {
  class: "catalogue-m"
};

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "catalogue-r"
  }, null, -1);
});

var _hoisted_41 = {
  key: 1,
  class: "empty"
};

var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加目录", -1);
});

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加谱文", -1);
});

var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加世系", -1);
});

var _hoisted_45 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加源流", -1);
});

var _hoisted_46 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt-box"
  }, [/*#__PURE__*/_createElementVNode("p", null, "您还没有正文目录内容，赶快新建吧~")], -1);
});

var _hoisted_47 = {
  class: "section"
};
var _hoisted_48 = {
  class: "top-bar"
};

var _hoisted_49 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "世系目录", -1);
});

var _hoisted_50 = /*#__PURE__*/_createTextVNode(" \" (添加世系表、世系分支等)\" ");

var _hoisted_51 = [_hoisted_49, _hoisted_50];
var _hoisted_52 = {
  key: 0,
  class: "m-content-edit2"
};
var _hoisted_53 = {
  class: "catalogue"
};
var _hoisted_54 = ["onClick"];
var _hoisted_55 = {
  class: "catalogue-l"
};
var _hoisted_56 = {
  class: "item-title"
};
var _hoisted_57 = {
  class: "branch-title"
};
var _hoisted_58 = {
  class: "branch-item"
};
var _hoisted_59 = {
  class: "catalogue-m"
};
var _hoisted_60 = {
  class: "member-options"
};
var _hoisted_61 = {
  class: "catalogue-r"
};
var _hoisted_62 = {
  class: "sub-catalogue"
};
var _hoisted_63 = {
  class: "cell sub-catalogue-cell"
};
var _hoisted_64 = {
  class: "catalogue-l"
};

var _hoisted_65 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "exclude"
  }, [/*#__PURE__*/_createElementVNode("span", null, "添加删除分支")], -1);
});

var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "catalogue-m"
  }, null, -1);
});

var _hoisted_67 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "exclude"
  }, [/*#__PURE__*/_createElementVNode("span", null, "换页节点")], -1);
});

var _hoisted_68 = {
  class: "member-options"
};
var _hoisted_69 = {
  key: 1,
  class: "empty"
};

var _hoisted_70 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加目录", -1);
});

var _hoisted_71 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加谱文", -1);
});

var _hoisted_72 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt-box"
  }, [/*#__PURE__*/_createElementVNode("p", null, "您还没有附录内容，赶快新建吧~")], -1);
});

var _hoisted_73 = {
  class: "section"
};
var _hoisted_74 = {
  class: "top-bar"
};

var _hoisted_75 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "附录", -1);
});

var _hoisted_76 = /*#__PURE__*/_createTextVNode(" \" (如家规家训、名人传记、风俗礼仪、文献杂记、领谱字号、后记等)\" ");

var _hoisted_77 = [_hoisted_75, _hoisted_76];
var _hoisted_78 = {
  class: "m-content"
};
var _hoisted_79 = {
  key: 0,
  class: "catalogue"
};
var _hoisted_80 = ["onClick"];
var _hoisted_81 = {
  class: "catalogue-l"
};
var _hoisted_82 = {
  class: "item-title"
};
var _hoisted_83 = {
  class: "name"
};
var _hoisted_84 = {
  class: "catalogue-m"
};

var _hoisted_85 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "catalogue-r"
  }, null, -1);
});

var _hoisted_86 = {
  key: 1,
  class: "empty"
};

var _hoisted_87 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加目录", -1);
});

var _hoisted_88 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "+ 添加谱文", -1);
});

var _hoisted_89 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt-box"
  }, [/*#__PURE__*/_createElementVNode("p", null, "您还没有附录内容，赶快新建吧~")], -1);
});

var _hoisted_90 = {
  class: "info-side"
};
var _hoisted_91 = {
  class: "list"
};

var _hoisted_92 = /*#__PURE__*/_createTextVNode(" 保存 ");

var _hoisted_93 = {
  class: "item"
};

var _hoisted_94 = /*#__PURE__*/_createTextVNode(" 添加 ");

var _hoisted_95 = {
  class: "item"
};

var _hoisted_96 = /*#__PURE__*/_createTextVNode(" 目录 ");

var _hoisted_97 = {
  class: "item"
};

var _hoisted_98 = /*#__PURE__*/_createTextVNode(" 源流 ");

var _hoisted_99 = {
  class: "item"
};

var _hoisted_100 = /*#__PURE__*/_createTextVNode(" 上移 ");

var _hoisted_101 = {
  class: "item"
};

var _hoisted_102 = /*#__PURE__*/_createTextVNode(" 下移 ");

var _hoisted_103 = {
  class: "item"
};

var _hoisted_104 = /*#__PURE__*/_createTextVNode(" 删除 ");

var _hoisted_105 = {
  class: "item"
};

var _hoisted_106 = /*#__PURE__*/_createTextVNode(" 返回 ");

var _hoisted_107 = {
  class: "h-right"
};
var _hoisted_108 = {
  class: "search"
};
var _hoisted_109 = {
  class: "box clans"
};
var _hoisted_110 = {
  class: "list"
};
var _hoisted_111 = {
  class: "menu"
};
var _hoisted_112 = {
  class: "member-params"
};
var _hoisted_113 = {
  key: 0,
  class: "member-selection"
};
var _hoisted_114 = {
  key: 1,
  class: "member-search-result"
};
var _hoisted_115 = {
  class: "list"
};
var _hoisted_116 = {
  class: "menu"
};
var _hoisted_117 = {
  class: "cell"
};
var _hoisted_118 = {
  class: "text"
};
var _hoisted_119 = ["onClick"];
var _hoisted_120 = {
  class: "text"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AddBookDialog from '@/components/dialogs/addBookDialog.vue';
import { getPedigreeBookList, saveBook, getBookDetail } from '@/api/book';
import { getPedigreeDetail } from '@/api/pedigreeDetail';
import { getPedigreeList } from '@/api/pedigree';
import { getSpectrumList, getSpectrumContent } from '@/api/spectrum';
import BoxSearch from '@/components/common/boxSearch.vue';
import LineSearch from '@/components/common/lineSearch.vue';
import PadigreeTree from './pedigreeTree';
import { rankPedigree, rankLevel } from '@/utils/filter.js';
import { options } from './components/options';
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var dialogVisible = ref(false);
    var dialogTitle = ref('');
    var dialogTableValue = ref([]);
    var bookList = ref([]);
    var bookData = ref({});
    var fenType = ref(0);
    var level = ref(0);
    var memberSelect = ref(true);
    var levelArray = ref([]);
    var checked1 = true;
    var pedigreeValue = ref(0);
    var activeName = ref('pedigree');
    var pedigreeId = ref(0);
    var topSelected = ref('');

    var levelInit = function levelInit() {
      var arr2 = new Array([]);

      for (var i = 0; i < 100; i++) {
        var a = {};
        a.name = rankLevel(i);
        a.id = i;
        arr2.push(a);
      }

      levelArray.value = arr2;
    };

    var initBookList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPedigreeBookList();

              case 2:
                bookList.value = _context.sent;
                _context.next = 5;
                return getPedigreeList();

              case 5:
                pedigreeList.value = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initBookList() {
        return _ref.apply(this, arguments);
      };
    }();

    var initData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(route.query.id);
                _context2.next = 3;
                return getBookDetail(route.query.id);

              case 3:
                res = _context2.sent;

                if (res.data == null) {
                  res.data = {};
                }

                bookData.value = res;
                pedigreeId.value = res.pedigreeId;
                initSpectrumList();
                initPedigreeData();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function initData() {
        return _ref2.apply(this, arguments);
      };
    }();

    levelInit();
    initBookList();
    initData();

    var handleDialogValue = function handleDialogValue() {
      dialogTitle.value = '创建谱书';
      dialogTableValue.value = {};
      dialogVisible.value = true;
    };

    var contentsSelect = function contentsSelect(item, a) {
      bookList.value.forEach(function (element) {
        element.status = false;
        element.bookList.forEach(function (t) {
          t.selected = false;
        });
      });
      item.status = true;
      a.selected = true;
      router.replace({
        name: 'BookDetails',
        query: {
          id: a.id
        }
      });
      initData();
    };

    var resSpectrum = ref([]);
    var resPedigreeList = ref([]); // 右侧谱系和谱文列表重置

    var initSpectrumList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var b;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                resSpectrum.value = null;
                _context3.next = 3;
                return getSpectrumList(pedigreeId.value);

              case 3:
                b = _context3.sent;

                if (b.length > 0) {
                  resSpectrum.value = b[0].outlines;
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function initSpectrumList() {
        return _ref3.apply(this, arguments);
      };
    }();

    var pedigreeList = ref([]);

    var initPedigreeData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getPedigreeDetail(pedigreeId.value);

              case 2:
                res = _context4.sent;
                data = bookData.value;

                if (data.data.pedigree == null) {
                  data.data.pedigree = {};
                  data.data.pedigree = res;
                }

                res[0].lastItem = true;
                res[0].ranking = '始祖';

                if (res && res.length > 0) {
                  initList(res, 0);
                }

                resPedigreeList.value = res;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function initPedigreeData() {
        return _ref4.apply(this, arguments);
      };
    }();

    var num = 0;

    var initList = function initList(res, level) {
      res.forEach(function (item) {
        item.status = true;
        item.selected = false;

        if (item.ranking !== '始祖') {
          item.ranking = rankPedigree(item.sex, item.rankingId);
        }

        item.levelName = rankLevel(level);
        item.lenvel = level; // 判断有没有 child

        if (item.child != null && item.child.length > 0) {
          item.childCount = item.child.length;

          if (num !== level) {
            num = level;
          }

          if (level < 3) {
            item.expand = true;
          } else {
            item.expand = false;
          }

          item.hasbranch = true;
          item.groupHead = 'group';
          initList(item.child, ++num);
        } else {
          item.hasbranch = false;
          item.groupHead = 'nullcList';
        }
      });
    };

    var addCatalogue = function addCatalogue() {
      ElMessageBox.prompt('目录名称', '添加目录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref5) {
        var value = _ref5.value;
        ElMessage({
          type: 'success',
          message: "Your email is:".concat(value)
        });
      }).catch(function () {
        ElMessage({
          type: 'info',
          message: '取消输入'
        });
      });
    };

    var addSpectrum = function addSpectrum(topName) {
      clearSelected();
      var data = bookData.value;

      switch (topName) {
        case 'head':
          {
            if (data.data.head == null) {
              data.data.head = [];
            }

            var res1 = {
              name: '请添加谱文',
              spectrumName: '请选择',
              selected: true
            };
            data.data.head.push(res1);
            break;
          }

        case 'catalogue':
          {
            if (data.data.catalogue == null) {
              data.data.catalogue = [];
            }

            var res2 = {
              name: '请添加谱文',
              spectrumName: '请选择',
              selected: true
            };
            data.data.catalogue.push(res2);
            break;
          }

        case 'appendix':
          {
            if (data.data.appendix == null) {
              data.data.appendix = [];
            }

            var res3 = {
              name: '请添加谱文',
              spectrumName: '请选择',
              selected: true
            };
            data.data.appendix.push(res3);
            break;
          }
      }

      bookData.value = data;
      console.log(bookData.value);
      activeName.value = 'spectrum';
      topSelected.value = topName;
    };

    var insertSpectrum = function insertSpectrum(item) {
      console.log(item);

      switch (topSelected.value) {
        case 'head':
          {
            bookData.value.data.head.forEach( /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(t) {
                var b;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!(t.selected === true)) {
                          _context5.next = 9;
                          break;
                        }

                        _context5.next = 3;
                        return getSpectrumContent(item.id);

                      case 3:
                        b = _context5.sent;
                        t.name = item.title;
                        t.spectrumName = item.title;
                        t.spectrumId = item.spectrumId;
                        t.outlineId = item.outlineId;
                        t.content = b.content;

                      case 9:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x) {
                return _ref6.apply(this, arguments);
              };
            }());
            break;
          }

        case 'catalogue':
          {
            bookData.value.data.catalogue.forEach( /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(t) {
                var b;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!(t.selected === true)) {
                          _context6.next = 9;
                          break;
                        }

                        _context6.next = 3;
                        return getSpectrumContent(item.id);

                      case 3:
                        b = _context6.sent;
                        t.name = item.title;
                        t.spectrumName = item.title;
                        t.spectrumId = item.spectrumId;
                        t.outlineId = item.outlineId;
                        t.content = b.content;

                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function (_x2) {
                return _ref7.apply(this, arguments);
              };
            }());
            break;
          }

        case 'appendix':
          {
            bookData.value.data.appendix.forEach( /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(t) {
                var b;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!(t.selected === true)) {
                          _context7.next = 9;
                          break;
                        }

                        _context7.next = 3;
                        return getSpectrumContent(item.id);

                      case 3:
                        b = _context7.sent;
                        t.name = item.title;
                        t.spectrumName = item.title;
                        t.spectrumId = item.spectrumId;
                        t.outlineId = item.outlineId;
                        t.content = b.content;

                      case 9:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x3) {
                return _ref8.apply(this, arguments);
              };
            }());
            break;
          }
      }
    };

    var handelSaveBook = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return saveBook(bookData.value);

              case 2:
                ElMessage({
                  message: '保存成功',
                  type: 'success'
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function handelSaveBook() {
        return _ref9.apply(this, arguments);
      };
    }();

    var pedigreeSelectChange = function pedigreeSelectChange(e) {
      pedigreeId.value = e;
      initPedigreeData();
    };

    var clearSelected = function clearSelected() {
      if (bookData.value.data.head != null && bookData.value.data.head.length > 0) {
        bookData.value.data.head.forEach(function (t) {
          t.selected = false;
        });
      }

      if (bookData.value.data.catalogue != null && bookData.value.data.catalogue.length > 0) {
        bookData.value.data.catalogue.forEach(function (t) {
          t.selected = false;
        });
      }

      if (bookData.value.data.pedigree != null && bookData.value.data.pedigree.length > 0) {
        bookData.value.data.pedigree.forEach(function (t) {
          t.selected = false;
        });
      }

      if (bookData.value.data.appendix != null && bookData.value.data.appendix.length > 0) {
        bookData.value.data.appendix.forEach(function (t) {
          t.selected = false;
        });
      }
    };

    var changeSelected = function changeSelected(item, topName) {
      clearSelected();
      item.selected = true;
      topSelected.value = topName;
    };

    var triggerMenu = function triggerMenu(item) {
      console.log(item);
      bookData.value.data.pedigree.forEach(function (t) {
        if (t.selected === true) {
          t.name = item.name;
        }
      });
    };

    return function (_ctx, _cache) {
      var _component_document_add = _resolveComponent("document-add");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_Reading = _resolveComponent("Reading");

      var _component_Delete = _resolveComponent("Delete");

      var _component_caret_right = _resolveComponent("caret-right");

      var _component_document = _resolveComponent("document");

      var _component_paperclip = _resolveComponent("paperclip");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_el_tabs = _resolveComponent("el-tabs");

      var _component_edit_pen = _resolveComponent("edit-pen");

      var _component_el_button = _resolveComponent("el-button");

      var _component_connection = _resolveComponent("connection");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_delete = _resolveComponent("delete");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_circle_plus = _resolveComponent("circle-plus");

      var _component_sort_up = _resolveComponent("sort-up");

      var _component_sort_down = _resolveComponent("sort-down");

      var _component_refresh_left = _resolveComponent("refresh-left");

      var _component_tickets = _resolveComponent("tickets");

      var _component_back = _resolveComponent("back");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tooltip, {
        class: "item",
        effect: "light",
        content: "添加谱书",
        placement: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "leftButton",
            "render-header": "123",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return handleDialogValue();
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_document_add)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        class: "item",
        effect: "light",
        content: "复制谱书",
        placement: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "leftButton",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.handleCategoryDialogValue();
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Reading)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        class: "item",
        effect: "light",
        content: "删除",
        placement: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "leftButton"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Delete)];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createVNode(LineSearch), _createVNode(_component_el_tabs, {
        type: "border-card",
        class: "tabCard"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tab_pane, {
            label: "我的谱书"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookList.value, function (item) {
                return _openBlock(), _createElementBlock("div", {
                  class: "clan",
                  key: item.id
                }, [_createElementVNode("div", {
                  class: _normalizeClass(["title first-title line-word", {
                    on: item.status
                  }])
                }, [_createVNode(_component_el_icon, {
                  class: "el-icon-right"
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_caret_right)];
                  }),
                  _: 1
                }), _createVNode(_component_el_icon, {
                  class: "h-icon-wenjian"
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_document)];
                  }),
                  _: 1
                }), _createTextVNode(" " + _toDisplayString(item.pedigreeName), 1)], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.bookList, function (a) {
                  return _openBlock(), _createElementBlock("div", {
                    class: "sub-clan",
                    key: a.id
                  }, [_createElementVNode("div", {
                    class: "article",
                    onClick: function onClick($event) {
                      return contentsSelect(item, a);
                    }
                  }, [_createElementVNode("div", {
                    class: _normalizeClass(["txt line-word", {
                      on: a.selected
                    }])
                  }, [_createVNode(_component_el_icon, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_paperclip)];
                    }),
                    _: 1
                  }), _createTextVNode(" " + _toDisplayString(a.name), 1)], 2)], 8, _hoisted_7)]);
                }), 128))]);
              }), 128))])];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "范例库"
          })];
        }),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: _normalizeClass(["top-left", {
          selected: topSelected.value == 'head'
        }])
      }, _hoisted_14, 2)]), _createElementVNode("div", _hoisted_15, [bookData.value.data && bookData.value.data.head.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookData.value.data.head, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          onClick: function onClick($event) {
            return changeSelected(item, 'head');
          }
        }, [_createElementVNode("div", {
          class: _normalizeClass(["cell catalogue-cell", {
            selected: item.selected
          }])
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_document)];
          }),
          _: 1
        }), _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1), _createVNode(_component_el_icon, {
          class: "icon-rename"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_edit_pen)];
          }),
          _: 1
        })])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_paperclip)];
          }),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(item.spectrumName), 1)]), _hoisted_22], 2)], 8, _hoisted_17);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: addCatalogue
      }, {
        default: _withCtx(function () {
          return [_hoisted_24];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return addSpectrum('head');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_25];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_26];
        }),
        _: 1
      })]), _hoisted_27]))])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
        class: _normalizeClass(["top-left", {
          selected: topSelected.value == 'catalogue'
        }])
      }, _hoisted_32, 2)]), _createElementVNode("div", _hoisted_33, [bookData.value.data && bookData.value.data.catalogue && bookData.value.data.catalogue.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookData.value.data.catalogue, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.name,
          onClick: function onClick($event) {
            return changeSelected(item, 'catalogue');
          }
        }, [_createElementVNode("div", {
          class: _normalizeClass(["cell catalogue-cell", {
            selected: item.selected
          }])
        }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_document)];
          }),
          _: 1
        }), _createElementVNode("div", _hoisted_38, _toDisplayString(item.name), 1), _createVNode(_component_el_icon, {
          class: "icon-rename"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_edit_pen)];
          }),
          _: 1
        })])]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_paperclip)];
          }),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(item.spectrumName), 1)]), _hoisted_40], 2)], 8, _hoisted_35);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_42];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return addSpectrum('catalogue');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_43];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_44];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_45];
        }),
        _: 1
      })]), _hoisted_46]))])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
        class: _normalizeClass(["top-left", {
          selected: topSelected.value == 'pedigree'
        }])
      }, _hoisted_51, 2)]), bookData.value.data && bookData.value.data.pedigree && bookData.value.data.pedigree.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookData.value.data.pedigree, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.name,
          onClick: function onClick($event) {
            return changeSelected(item, 'pedigree');
          }
        }, [_createElementVNode("div", {
          class: _normalizeClass(["cell catalogue-cell", {
            selected: item.selected
          }])
        }, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_document)];
          }),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString(item.name) + "公派下", 1), _createVNode(_component_el_icon, {
          class: "icon-rename"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_edit_pen)];
          }),
          _: 1
        })]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, _toDisplayString(item.name), 1)])]), _createElementVNode("div", _hoisted_59, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_connection)];
          }),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_60, [_createVNode(_component_el_checkbox, {
          modelValue: checked1,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
            return $event, _readOnlyError("checked1");
          }),
          label: "检索表",
          size: "samll"
        }), _createVNode(_component_el_checkbox, {
          modelValue: checked1,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
            return $event, _readOnlyError("checked1");
          }),
          label: "世系图",
          size: "samll"
        }), _createVNode(_component_el_checkbox, {
          modelValue: checked1,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
            return $event, _readOnlyError("checked1");
          }),
          label: "世系表",
          size: "samll"
        })]), _createElementVNode("div", _hoisted_61, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_delete)];
          }),
          _: 1
        })])], 2)], 8, _hoisted_54);
      }), 128)), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createVNode(_component_el_select, {
        modelValue: pedigreeValue.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return pedigreeValue.value = $event;
        }),
        placeholder: "全部后代",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), function (item) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.text,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"]), _hoisted_65]), _hoisted_66, _hoisted_67, _createElementVNode("div", _hoisted_68, [_createVNode(_component_el_checkbox, {
        modelValue: checked1,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
          return $event, _readOnlyError("checked1");
        }),
        label: "从奇数页开始",
        size: "samll"
      })])])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_69, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_70];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return addSpectrum('appendix');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_71];
        }),
        _: 1
      })]), _hoisted_72]))]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", {
        class: _normalizeClass(["top-left", {
          selected: topSelected.value == 'appendix'
        }])
      }, _hoisted_77, 2)]), _createElementVNode("div", _hoisted_78, [bookData.value.data && bookData.value.data.appendix && bookData.value.data.appendix.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_79, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookData.value.data.appendix, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.name,
          onClick: function onClick($event) {
            return changeSelected(item, 'appendix');
          }
        }, [_createElementVNode("div", {
          class: _normalizeClass(["cell catalogue-cell", {
            selected: item.selected
          }])
        }, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_document)];
          }),
          _: 1
        }), _createElementVNode("div", _hoisted_83, _toDisplayString(item.name), 1), _createVNode(_component_el_icon, {
          class: "icon-rename"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_edit_pen)];
          }),
          _: 1
        })])]), _createElementVNode("div", _hoisted_84, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_paperclip)];
          }),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(item.spectrumName), 1)]), _hoisted_85], 2)], 8, _hoisted_80);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_hoisted_87];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return addSpectrum('appendix');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_88];
        }),
        _: 1
      })]), _hoisted_89]))])])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", {
        class: "item",
        style: {
          "color": "rgb(105, 2, 2)"
        },
        onClick: handelSaveBook
      }, [_createVNode(_component_svg_icon, {
        icon: "save",
        class: "icon"
      }), _hoisted_92]), _createElementVNode("div", _hoisted_93, [_createVNode(_component_el_icon, {
        class: "icon",
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return addSpectrum(topSelected.value);
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_circle_plus)];
        }),
        _: 1
      }), _hoisted_94]), _createElementVNode("div", _hoisted_95, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_circle_plus)];
        }),
        _: 1
      }), _hoisted_96]), _createElementVNode("div", _hoisted_97, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_circle_plus)];
        }),
        _: 1
      }), _hoisted_98]), _createElementVNode("div", _hoisted_99, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_sort_up)];
        }),
        _: 1
      }), _hoisted_100]), _createElementVNode("div", _hoisted_101, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_sort_down)];
        }),
        _: 1
      }), _hoisted_102]), _createElementVNode("div", _hoisted_103, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_delete)];
        }),
        _: 1
      }), _hoisted_104]), _createElementVNode("div", _hoisted_105, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_refresh_left)];
        }),
        _: 1
      }), _hoisted_106])])])]), _createElementVNode("div", _hoisted_107, [_createVNode(_component_el_tabs, {
        type: "border-card",
        class: "tabCard",
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
          return activeName.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tab_pane, {
            label: "谱系",
            name: "pedigree"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createVNode(_component_el_select, {
                modelValue: pedigreeId.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                  return pedigreeId.value = $event;
                }),
                class: "m-2",
                placeholder: "Select",
                style: {
                  "width": "100%"
                },
                onChange: pedigreeSelectChange
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedigreeList.value, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createVNode(_component_el_select, {
                modelValue: fenType.value,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
                  return fenType.value = $event;
                }),
                class: "m-2",
                placeholder: "Select",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_option, {
                    label: "全部族员",
                    value: 0
                  }), _createVNode(_component_el_option, {
                    label: "分房",
                    value: 1
                  }), _createVNode(_component_el_option, {
                    label: "分屋",
                    value: 2
                  }), _createVNode(_component_el_option, {
                    label: "分支",
                    value: 3
                  }), _createVNode(_component_el_option, {
                    label: "分派",
                    value: 4
                  }), _createVNode(_component_el_option, {
                    label: "分庄",
                    value: 5
                  })];
                }),
                _: 1
              }, 8, ["modelValue"]), _createVNode(_component_el_select, {
                modelValue: level.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
                  return level.value = $event;
                }),
                class: "m-2",
                placeholder: "Select",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levelArray.value, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue"])]), _createVNode(BoxSearch), memberSelect.value ? (_openBlock(), _createElementBlock("div", _hoisted_113, [_createVNode(_unref(PadigreeTree), {
                list: resPedigreeList.value,
                onTriggerMenu: triggerMenu
              }, null, 8, ["list"])])) : (_openBlock(), _createElementBlock("div", _hoisted_114))])])];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "谱文",
            name: "spectrum"
          }, {
            default: _withCtx(function () {
              return [_createVNode(BoxSearch), _createElementVNode("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resSpectrum.value, function (item) {
                return _openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: item.id
                }, [_createElementVNode("div", _hoisted_117, [_createVNode(_component_el_icon, {
                  class: "icon"
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_tickets)];
                  }),
                  _: 1
                }), _createElementVNode("span", _hoisted_118, _toDisplayString(item.name), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.contents, function (a) {
                  return _openBlock(), _createElementBlock("div", {
                    class: "submenu",
                    key: a.id
                  }, [_createElementVNode("div", {
                    class: "cell",
                    onClick: function onClick($event) {
                      return insertSpectrum(a);
                    }
                  }, [_createVNode(_component_el_icon, {
                    class: "icon"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_back)];
                    }),
                    _: 1
                  }), _createElementVNode("span", _hoisted_120, _toDisplayString(a.title), 1)], 8, _hoisted_119)]);
                }), 128))]);
              }), 128))])])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])])]), dialogVisible.value ? (_openBlock(), _createBlock(AddBookDialog, {
        key: 0,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
          return dialogVisible.value = $event;
        }),
        dialogTitle: dialogTitle.value,
        onInitBookList: initBookList,
        dialogTableValue: dialogTableValue.value
      }, null, 8, ["modelValue", "dialogTitle", "dialogTableValue"])) : _createCommentVNode("", true)], 64);
    };
  }
};